import {useNavigate} from 'react-router-dom';
import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {selectAuth} from '@app/redux/selectors';
import {connect} from 'react-redux';
import {Row} from 'antd';
import {ROUTE_LOGIN} from '@app/navigations/RoutePathConstant';

const CommonAuthenticate = ({auth}: any) => {

  const navigate = useNavigate();
  console.log(auth);

  useEffect(() => {
    if (!auth.loggedIn) {
      navigate(ROUTE_LOGIN);
    }
  }, [auth.loggedIn, navigate]);

  return (
    <Row />
  );
};

CommonAuthenticate.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapState = (state: any) => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(CommonAuthenticate);
